var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fadeIn content-wrapper"},[_c('h2',[_vm._v(" "+_vm._s(_vm.$t('spotDevice.spotDevice'))+" ")]),_c('div',{staticClass:"card coming-soon"},[_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v(" "+_vm._s(_vm.$t('general.comingSoon'))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }